/* eslint-disable no-console */
import React from 'react';

import {collageOfColors} from '../../../../pages/netZero/constants/commonConstants';
import {sortBy} from '../../../../shared/commonFunctions';
import PieChartScopeProps from '../interfaces/PieChartScopeProps';

const PieScopeCustomizedLegend: React.FC<{data: PieChartScopeProps[]}> = ({
  data
}) => {
  const mainData = data?.map((item) => {
    return {...item, legendData: sortBy(item?.legendData, 'percent')};
  });

  return (
    <>
      <div
        style={{
          marginBottom: '10px',
          color: '#99B1C7',
          font: 'normal normal 600 12px/15px Montserrat'
        }}
      >
        TOP 3 FROM EACH
      </div>
      <ul
        className="recharts-default-legend"
        style={{padding: '0px', margin: '0px', textAlign: 'left'}}
      >
        {mainData?.map((e: PieChartScopeProps, index: number) => {
          return e.name ? (
            <div
              key={index}
              style={{
                marginBottom: '10px'
              }}
            >
              <li
                style={{
                  display: 'flex',
                  marginRight: '10px',
                  marginBottom: '5px',
                  alignItems: 'center'
                }}
              >
                <span
                  style={{
                    width: '7px',
                    height: '7px',
                    backgroundColor: `${e.fill ?? collageOfColors[index]}`,
                    borderRadius: '50%',
                    marginRight: '5px'
                  }}
                ></span>
                <span
                  className="recharts-legend-item-text"
                  style={{
                    color: '#677489',
                    font: 'normal normal 600 12px/15px Montserrat'
                  }}
                >
                  {e.name}
                </span>
              </li>
              <div className="customText">
                {e?.legendData.map((label, index) => {
                  return (
                    <div
                      key={index}
                    >{`${label?.percent}% ${label?.label} `}</div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div key={index}></div>
          );
        })}
      </ul>
    </>
  );
};

export default PieScopeCustomizedLegend;
